<template>
  <div class="page-wrapper">
    <div class="page-wrapper">
      <div class="container">
        <!-- content -->
        <div class="content">
          <!-- search-content -->
          <div class="search-content text-uppercase">
            <h2>Profile View Details</h2>
          </div>
          <div
            class="favourites-content-wrapper"
            v-if="profileViews.length !== 0"
          >
            <div
              class="favourite-content"
              v-for="(item, index) in profileViews"
              :key="index"
            >
              <a-row :gutter="[24]">
                <a-col :sm="3">
                  <BaseImageWrapper
                    wrapper-style="circle"
                    :name="item.viewByInstitution.collegeName || item.viewByInstitution.clubName"
                    :imageUrl="generateImageUrl(item.viewByInstitution.logo)"
                    :size="75"
                  />
                </a-col>
                <a-col :sm="16">
                  <div class="favourite-information-wrapper">
                    <div class="pointer-hover" @click="handleNameClick(item)">
                      <h2>{{ item.viewByInstitution.collegeName ||  item.viewByInstitution.clubName }}</h2>
                    </div>
                    <p>
                      {{ item.viewByInstitution.age && item.viewByInstitution.age.name 
                      }}{{ item.viewByInstitution.division && item.viewByInstitution.division.name || item.viewByInstitution.address1 }} •
                      {{ item.viewByInstitution.state && item.viewByInstitution.state.name  }} , {{ item.viewByInstitution.city || "-" }}
                    </p>
                    <p class="text-transform-none">
                      <span class="font-weight-bold"
                        >{{ item.viewBy.coachname }}({{ item.viewBy.position }})</span
                      >
                      viewed your profile
                      {{ item.updatedAt | convertToFromNowFormat }}
                    </p>
                    <p class="text-transform-none">
                      Total views by this coach:
                      <span class="font-weight-bold">{{ item.count }}</span>
                    </p>
                  </div>
                </a-col>
                <a-col :sm="3">
                  <p class="type-name font-weight-bold">
                    {{ item.viewByInstitution.collegeName ? 'College' : 'Club' }}
                  </p>
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
        <a-pagination
          class="margin-t-1"
          v-if="profileViewMeta.total"
          :total="profileViewMeta.total"
          v-model="systemPage"
          @change="dispatcher"
          :defaultPageSize="25"
        /> 
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Athlete } from "@/models";

const STORE_KEY = "athleteStore";
const FAVOURITE_STORE_KEY = "favouriteStore";

export default {
  data() {
    return {
      systemPage: 1,
    }
  },
  computed: {
    ...mapGetters({
      profileViews: `${STORE_KEY}/profileViews`,
      profileViewMeta: `${STORE_KEY}/profileViewMeta`,
      profileViewsLoading: `${STORE_KEY}/profileViewsLoading`
    }),
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getProfileViews`, { page: 1 , perPage: 25});
  },
  methods: {
    async dispatcher(page) {
      await this.$store.dispatch(`${STORE_KEY}/getProfileViews`, { page: page , perPage: 25});
    },
    handleFavouriteClick(item) {
      if (item.favC) {
        this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: Athlete.profileId(),
          favTo: item.viewByInstitution.id,
        });
        this.$store.dispatch(
          `${STORE_KEY}/unsetFavouriteForInstitution`,
          item.viewByInstitution.id
        );
        return;
      }
      this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavouriteForAthlete`, {
        favBy: Athlete.profileId(),
        favTo: item.viewByInstitution.id,
        typeFav: item.viewByInstitution.collegeName ? "college" : "clubTeam"
      });
      this.$store.dispatch(
        `${STORE_KEY}/setFavouriteForInstitution`,
        item.viewByInstitution.id
      );
    },
    handleNameClick(item) {
      if (item.viewByInstitution.collegeName)
        this.$router.push(
          `/${Athlete.profileId()}/college_profile/${item.viewByInstitution.id}/summary`
        );
      else
        this.$router.push(
          `/${Athlete.profileId()}/club_profile/${item.viewByInstitution.id}/summary`
        );
    }
  }
};
</script>

<style lang="sass" scoped>
.favourite-content
  p
    font-size: 14px
  .text-transform-none
    text-transform: none
  .font-weight-bold
    font-weight: 500
</style>
